import {SlideDown} from 'react-slidedown'

export default function Dropdown(props) {
    return (
      <SlideDown className={'my-dropdown-slidedown'} transitionOnAppear={false}>
        {props.open ? props.children : null}
      </SlideDown>
    )
  }